import { DefaultService } from '@/services/DefaultService';

export default class SafraService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(safra, contexto = 'agro') {
        return this._http
            .post(`${this._env}/${contexto}/safra/updatesituacao`, safra, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    findAll(column, order, page, limit, situacao, contexto = 'agro', ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/${contexto}/safra.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    // @71156 - busca as safras para serem exibidas no filtro de safra, na listagem de Agro visitas
    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/agro/safra/getcombo.json?situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    find(id, contexto = 'agro') {
        return this._http.get(`${this._env}/${contexto}/safra/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
            }
        );
    }

    save(form, contexto = 'agro') {
        return this._http.post(`${this._env}/${contexto}/safra`, form, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw err;
            }
        );
    }
}
